export default __webpack_public_path__ + "static/media/foto2.fab36555.jpg";